import { useEntityTable } from "@mirage/store/entityTableStore";
import { Divider, MenuItem } from "@mui/material";
import { GridColDef, GridColumnMenuContainer, GridColumnMenuSortItem, GridColumnMenuPinningItem, GridColumnMenuColumnsItem, useGridApiContext } from "@mui/x-data-grid-premium";
import React, { memo, useCallback } from "react";

interface ColumnMenuProps {
    colDef: GridColDef;
    hideMenu: (e: any) => void;
    id: string;
    labelledby: string;
    open: boolean;
    setPanelAnchorEl: (el: HTMLElement | null) => void;
}

const ColumnMenu: React.FC<ColumnMenuProps> = memo(({ colDef, open, hideMenu, setPanelAnchorEl }) => {
    const apiRef = useGridApiContext();
    const { setDateFilterPopper } = useEntityTable();
    const sortHandler = useCallback(() => {
        return;
    }, []);

    const filterHandler = useCallback(() => {
        const elementRef = apiRef.current.getColumnHeaderElement(colDef.field);
        if (colDef.type === "date" || colDef.type === "datetime") {
            setDateFilterPopper({ open: true, elementRef, fieldName: colDef.field });
        } else {
            setPanelAnchorEl(elementRef);
            apiRef.current.showFilterPanel(colDef.field);
        }
        apiRef.current.hideColumnMenu();
    }, [apiRef, colDef.field, colDef.type, setDateFilterPopper, setPanelAnchorEl]);

    const showColumnsHandler = useCallback(() => {
        return;
    }, []);

    const pinningHandler = useCallback(() => {
        return;
    }, []);

    return (
        <GridColumnMenuContainer hideMenu={hideMenu} colDef={colDef} open={open}>
            <GridColumnMenuSortItem onClick={sortHandler} colDef={colDef} />
            <MenuItem onClick={filterHandler}>Filter</MenuItem>
            <GridColumnMenuColumnsItem colDef={colDef} onClick={showColumnsHandler} />
            <Divider />
            <GridColumnMenuPinningItem colDef={colDef} onClick={pinningHandler} />
        </GridColumnMenuContainer>
    );
});

export default ColumnMenu;
